const { __, _x, _n, _nx } = wp.i18n;

/**
 * Implements the news popup.
 */
var Popup = ( function() {
	var C = function(){ return constructor.apply(this,arguments); };
	var p = C.prototype;

	p.modalQueue = null;

	function constructor( modalQueue ) {
		this.modalQueue = modalQueue;
	};

	// Opens (and possibly creates) the news popup.
	p.open = function() {
		var newsPopups = jQuery ( '.iportal-news-popup' );
		if ( newsPopups.length == 0 ) {
			this.createPopup();
		} else {
			this.modalQueue.enqueue(
				newsPopups.get(0) );
		}
	};

	// Retreives and inserts news content into popup.
	p.insertContent = function( $popup ) {
		var jqxhr = jQuery.ajax( {
			url: wpApiSettings.root + 'iportal/v1/news/content',
			beforeSend: function( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
			},
		} ).done( function( response ) {
			$popup.html( response );
		} ).fail( function() {
			$popup.html( '<div class="alert alert-danger">'
									 + __( 'Could not retrieve content, please try again later.', 'iportal-news' )
									 + '</div>' );
		} );
	};

	// Creates news popup
	p.createPopup = function() {
		var $popup = jQuery( '<div class="iportal-news-popup"><div class="iportal-news-popup__content"><div class="d-flex justify-content-center"><div class="mt-5 mb-5 spinner-border text-primary" role="status"><span class="sr-only">' + __( 'Loading...', 'iportal-core' ) + '</span></div></div></div></div>' );
		$popup
			.addClass( 'modal' )
			.attr( 'tabindex', '-1' )
			.attr( 'role', 'dialog' )
			.wrapInner( '<div class="modal-body"></div>' )
			.wrapInner( '<div class="modal-content"></div>' )
			.wrapInner( '<div class="modal-dialog modal-lg" role="document"></div>' );
		$popup.find( '.modal-body' ).before(
			' <div class="modal-header">'
				+ '<h2 class="modal-title">' + __( 'News', 'iportal-core' ) + '</h2> '
				+ '<button type="button" class="close" data-dismiss="modal" aria-label="Close"> '
				+ '<span aria-hidden="true">&times;</span></button></div>' );

		var self = this;
		$popup.on( 'show.bs.modal', function() {
			self.insertContent( $popup.find( '.modal-body' ) );
		} );

		this.modalQueue.enqueue(
			$popup.get(0) );
	};

	return C;
} )();

export default Popup;